import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  imageContainer: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundColor: 'transparent',
  },

  image: {
    objectFit: 'cover',
    width: '100%',
  },

  iconButton: {
    width: 36,
    padding: 0,
    minWidth: 0,

    '& svg': {
      width: 16,
      height: 16,
    },
  },
}));
